import { createSelector } from 'reselect'

import { selectAuthToken } from './selectAuthToken'

export const selectTokenExpirationTime = createSelector([selectAuthToken], (authToken) =>
  authToken ? JSON.parse(atob(authToken.split('.')[1])).exp : 0
)
